import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function StickyBar() {
  const [isVisible, setIsVisible] = useState(true);
  const [startTime] = useState(() => Date.now());
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      const elapsed = Math.floor((Date.now() - startTime) / 1000);
      setTimeLeft(Math.max(15 * 60 - elapsed, 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [startTime]);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  return <AnimatePresence data-id="element-313">
      {isVisible && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: 'auto',
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="bg-[#111111] text-white relative z-50 overflow-hidden will-change-transform gpu-layer" data-id="element-314">
          {/* Gold accent line at bottom */}
          <div className="absolute bottom-0 left-0 right-0 h-[2px] bg-[#C9A84C]" data-id="element-315"></div>

          <div className="px-4 py-2 flex flex-col items-center justify-center relative gap-0.5" data-id="element-316">
            {/* Main line: Oferta + Timer */}
            <div className="flex items-center gap-2 text-center" data-id="element-317">
              <span className="text-[11px] md:text-sm font-bold tracking-wider uppercase" data-id="element-318">
                🔥 OFERTA DE LANZAMIENTO URUGUAY:
              </span>
              <span className="text-[#C9A84C] font-bold text-sm md:text-base tabular-nums tracking-wide" data-id="element-319">
                {minutes}:{seconds}
              </span>
            </div>

            {/* Sub line: Discount info */}
            <p className="text-[10px] md:text-xs text-gray-400 font-medium tracking-wide uppercase" data-id="element-320">
              50% Descuento + 5 Bonos de Regalo
            </p>

            {/* Close button */}
            <button onClick={() => setIsVisible(false)} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-white/10 rounded-full transition-colors" aria-label="Cerrar" data-id="element-321">
              <XIcon className="w-4 h-4 text-gray-500" data-id="element-322" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}